export const API_Const = {
  dashActiveUser: "dashboard/active-user",
  chartDataApi: "dashboard/chart",
  wsmValue: "dashboard/values",
  transactionDetails: "dashboard/transactions?",
  transactionChart: "dashboard/transaction-chart/",
  wsmBurnt: "dashboard/wsm-burnt",
  leaderboards: "leaderboards",
  leaderboardRanking: "ranking/leaderboard/",
  wageredLeaderboardRanking: "ranking/wager-leaderboard/",
  lootboxes: {
    games: "games",
    game: "game",
    balance: "game/balance",
    bet: "game/bet",
    getUserPrizes: "game/prize/userprizes",
    getNftDetails: (prizeId: number) => `game/prize/nft/${prizeId}`,
    nftClaim: "game/prize/nftclaim",
    nftCashout: 'game/prize/nftcashout',
    prizeCashout: 'game/prize/prizecashout',
    authorize: "game/authorize",
    bonus: 'game/bonus/get' // Used for marketing free spin Balance -> Gives both inGame and marketing free spin balance 
  },
  vip: {
    details: "vip/details",
    vipBenefits: "all-vip-benefits",
    vipLevels: "level-masters",
    vipLevel: "level-master",
    claimReward: "claim-reward/",
    levelUp: "levelup",
  },
  login: "auth/login"
};

export const OPEN_SEA_APIS = {
  collection: (collectionSnug: string) => `collections/${collectionSnug}`,
  nft: (chain: string, address: string, identifier: number) =>
    `chain/${chain}/contract/${address}/nfts/${identifier}`,
  listing: (collection_slug: string, identifier: number) =>
    `listings/collection/${collection_slug}/nfts/${identifier}/best`,
};
